<template>
  <div class="container">
    <div class="row">
      <div
        class="col-12 d-flex flex-row justify-content-between align-items-center top"
      >
        <router-link to="/" class="logo">
          <transition name="fade-logo">
            <img
              src="static/logo.png"
              alt="Məlumat Portalı"
              key="logo"
              v-if="homePage"
            />
            <img src="static/left.png" alt="NOT Home Page" key="left" v-else />
          </transition>
        </router-link>

        <Slide
          right
          disableEsc
          :closeOnNavigation="true"
          @openMenu="handleOpenMenu"
          @closeMenu="handleCloseMenu"
        >
          <router-link to="/">Əsas səhifə</router-link>
          <router-link to="/about">Haqqımızda</router-link>
          <router-link to="/contact">Bizimlə əlaqə</router-link>
          <div class="social d-flex flex-column">
            <a
              href="https://www.facebook.com/azelocal/"
              target="_blank"
              rel="noreferrer"
            >
              <img src="static/facebook.svg" alt="facebook" /> azelocal
            </a>
            <a
              href="https://www.instagram.com/azelocal/"
              target="_blank"
              rel="noreferrer"
            >
              <img src="static/instagram.svg" alt="instagram" /> azelocal
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=az.local.pwa"
              target="_blank"
              @click="googlePlay"
            >
              <img
                src="static/google-play.webp"
                alt="google play"
                class="google-play"
              />
            </a>
          </div>
        </Slide>
      </div>
      <!--<div class="offset-2 col-8">
        <div class="search-wrapper d-flex flex-row align-items-center justify-content-between">
          <img src="/static/icons/search.svg" />
          <input type="text" placeholder="məlumati daxil edin">
          <button>Axtar</button>
        </div>
        <div class="popular d-flex align-items-center justify-content-start">
          <p>ən cox istifadə olunan:</p>
          <router-link to="/pension">pensiya kalkulatoru</router-link>, 
          <router-link to="/communal">kommunal xidmətlər</router-link>
        </div>
      </div>-->
    </div>
    <div id="overlay" ref="overlay"></div>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  data() {
    return {
      homePage: true,
    };
  },

  components: {
    Slide,
  },

  watch: {
    $route(to, from) {
      if (this.$route.path === "/") {
        this.homePage = true;
      } else if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.homePage = false;
      }
    },
  },

  methods: {
    handleOpenMenu() {
      this.$refs.overlay.style.display = "block";
    },
    handleCloseMenu() {
      this.$refs.overlay.style.display = "none";
    },
    googlePlay() {
      this.$ga.event("googlePlay", "click", "googlePlayNav", 1);
    },
  },
};
</script>

<style scoped>
.fade-logo-enter,
.fade-logo-enter-active,
.fade-logo-leave-to,
.fade-logo-leave-active {
  transition: all 0.2s ease;
  opacity: 0;
}

a {
  text-decoration: none;
  color: #fff;
}
.top .logo img {
  width: 200px;
}
.search-wrapper input {
  padding: 1rem 2rem 1rem 3rem;
  border-radius: 5px 0 0 5px;
  height: 50px;
}
.search-wrapper button {
  border-radius: 0 5px 5px 0;
}
.search-wrapper img {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: -2rem;
  z-index: 100;
}
.popular a {
  color: #fff;
  text-decoration: none;
  border-bottom: 1px dashed #f0f0f0;
  margin-left: 0.5rem;
}
.social {
  margin-top: 30px;
  padding: 0;
}
.social:before {
  content: "";
  width: 50%;
  height: 2px;
  background: #eee;
  margin-bottom: 30px;
}
.social a {
  text-decoration: none;
  display: flex;
  align-items: center;
}
.social img {
  display: block;
  width: 16px;
  height: 16px;
  opacity: 0.6;
  margin-right: 10px;
}
.social img.google-play {
  width: 110px;
  height: auto;
  opacity: 1;
  margin: 1rem 0;
}
#overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2;
  cursor: pointer;
}
@media only screen and (max-width: 768px) {
  .top {
    margin-bottom: 0;
  }
  .top .logo {
    display: block;
    width: 150px;
    height: 53px;
  }
  .top .logo img {
    width: 150px;
  }
}
</style>

<style>
.bm-burger-button {
  top: calc(50% - 18px);
}
.bm-cross-button {
  transform: translateX(-15px);
}
.bm-cross {
  left: 10px;
  top: 5px;
}
.bm-burger-bars {
  background-color: #fafafa;
  border-radius: 2px;
  height: 18%;
}
.bm-menu {
  background-color: #fafafa;
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2),
    0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  transition: width ease 0.15s;
}
.bm-item-list a {
  color: #555;
  padding: 0.5rem;
}
.bm-overlay {
  background: inherit;
  overflow: hidden;
  margin-right: 17px;
}
@media only screen and (max-width: 768px) {
  .bm-overlay {
    margin-right: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue